import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './styles/element-plus-compat.css'
import './styles/element-icons.css'
import './styles/module-page-typography.css'
import router from './router'
import AppIcon from '@/components/AppIcon.vue'
import TableActionBtn from '@/components/TableActionBtn.vue'
import { registerElementPlusIcons, resolveLegacyIcon } from '@/icons'
import { preloadProductSeries } from '@/api/productSeriesStore'

// ResizeObserver 在表格/Tab 布局重算时可能触发浏览器无害告警，避免 dev overlay 误报
const RESIZE_OBSERVER_LOOP_RE = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/

window.addEventListener(
  'error',
  event => {
    if (RESIZE_OBSERVER_LOOP_RE.test(event.message || '')) {
      event.stopImmediatePropagation()
    }
  },
  true,
)

const app = createApp(App)

registerElementPlusIcons(app)
app.component('AppIcon', AppIcon)
app.component('TableActionBtn', TableActionBtn)
app.config.globalProperties.legacyIcon = resolveLegacyIcon
app.mixin({
  methods: {
    legacyIcon: resolveLegacyIcon,
  },
})
app.use(router)
app.use(ElementPlus, { locale: zhCn })
// 仅在已登录时预热产品系列缓存。
// 未登录（登录页）时该接口会返回 502，被响应拦截器判定为登录超时并弹出
// “登录已过期，请重新登录”误提示，同时产生无意义的请求与控制台报错。
// 登录后的页面（产品列表/产品表单）在 mounted 时会各自预加载，功能不受影响。
if (localStorage.getItem('token')) {
  preloadProductSeries()
}
app.mount('#app')

// 清理旧调试代码残留的 temp-err-banner 元素（轮询确保彻底清除）
function removeStaleBanner() {
  const staleBanner = document.getElementById('temp-err-banner')
  if (staleBanner) {
    staleBanner.remove()
    return true
  }
  return false
}
removeStaleBanner()
// 每 500ms 检查一次，直到连续 5 次都找不到残留元素后停止
let checkCount = 0
const checkInterval = setInterval(() => {
  if (removeStaleBanner()) {
    checkCount = 0
  } else {
    checkCount++
    if (checkCount >= 5) {
      clearInterval(checkInterval)
    }
  }
}, 500)
